import { ShortMessageTemplatesGetters } from './partials/templates'

export const ShortMessageGetters = {
  ...ShortMessageTemplatesGetters,
}
